import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100vh;
  font-size: 16px;
  padding: 20px;
  width: 100vw;
`;

export const ConfirmationDialog = styled.div`
  max-width: 500px;
  padding: 30px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgb(0 0 0 / 10%);
  font-family: 'Open Sans', sans-serif;
`;

export const DialogTitle = styled.h3`
  margin-top: 0;
  margin-bottom: 20px;
  color: #333;
`;

export const DialogText = styled.p`
  margin-bottom: 20px;
  color: #666;
  line-height: 1.5;
`;

export const DialogTextLast = styled(DialogText)`
  margin-bottom: 30px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`;

export const CancelButton = styled.button`
  padding: 10px 20px;
  font-size: 14px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #fff;
  color: #333;
  cursor: pointer;

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const ConfirmButton = styled.button`
  padding: 10px 20px;
  font-size: 14px;
  border: none;
  border-radius: 4px;
  background-color: #007bff;
  color: #fff;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }
`;

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 16px;
`;

export const ErrorMessage = styled.div`
  color: red;
  margin-bottom: 16px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 16px;
`;
